import OrganizationUpdatesReducer from './OrganizationUpdatesReducer';

export default from './OrganizationUpdatesContainer';

export const OrganizationUpdatesReducers = {
  OrganizationUpdatesReducer,
};
